var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVigilLogoTm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 39,
    viewBox: "0 0 170 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 890"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 889"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vigil"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.14 15.1292L58.3029 26.9675L62.4225 15.1292H65.5664L59.7339 30.5234H56.8502L50.9961 15.1292H54.14Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2187 30.5234V15.1292H83.2108V30.5234H80.2187Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.828 30.6318C104.831 30.6318 103.884 30.4294 102.988 30.0247C102.106 29.62 101.325 29.0635 100.646 28.3552C99.9811 27.6324 99.4607 26.7941 99.0849 25.8401C98.7091 24.8861 98.5211 23.8525 98.5211 22.7395C98.5211 21.6843 98.7091 20.6942 99.0849 19.7691C99.4607 18.8296 99.9883 18.0056 100.668 17.2974C101.347 16.5891 102.142 16.0326 103.053 15.6278C103.963 15.2231 104.953 15.0208 106.023 15.0208C107.469 15.0208 108.704 15.3315 109.731 15.9531C110.771 16.5602 111.552 17.3696 112.072 18.3815L109.839 20.0293C109.449 19.2632 108.9 18.6778 108.191 18.2731C107.497 17.8683 106.739 17.666 105.915 17.666C105.264 17.666 104.672 17.8033 104.137 18.0779C103.602 18.3526 103.139 18.7284 102.749 19.2054C102.359 19.6824 102.055 20.2317 101.838 20.8532C101.636 21.4748 101.535 22.1324 101.535 22.8263C101.535 23.5635 101.643 24.2428 101.86 24.8644C102.091 25.4859 102.409 26.028 102.814 26.4905C103.233 26.9531 103.718 27.3217 104.267 27.5963C104.816 27.8565 105.423 27.9866 106.088 27.9866C106.869 27.9866 107.613 27.7842 108.321 27.3795C109.044 26.9748 109.716 26.3821 110.338 25.6016V28.5503C109.051 29.938 107.548 30.6318 105.828 30.6318ZM110.121 24.7993H107.02V22.6094H112.593V30.5234H110.121V24.7993Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.152 30.5234V15.1292H131.144V30.5234H128.152Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.365 30.5234V15.1292H150.357V27.8999H158.206V30.5234H147.365Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2251 10.7773C15.3615 24.0402 12.7929 28.442 12.7929 28.6543C12.7929 28.8777 16.9849 36.1414 18.3524 38.2877C18.6059 38.6859 19.2025 38.6763 19.4426 38.2702L20.378 36.6876C21.184 35.3238 25.3102 28.351 29.5471 21.1926C33.7837 14.0343 37.2859 8.09198 37.3297 7.98774C37.3732 7.88328 34.5986 7.82544 31.1641 7.85882L28.2995 7.88681C26.2041 7.90729 24.2752 9.00602 23.2251 10.7773Z",
    fill: "url(#paint0_linear_4079_33817)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8957 18.104C17.6733 16.0351 16.236 13.608 14.5577 10.7773C13.5076 9.00605 11.5787 7.90732 9.48328 7.88684L6.61875 7.85884C3.18418 7.82547 0.40961 7.8833 0.453142 7.98777C0.496908 8.092 3.99911 14.0343 8.23574 21.1927C12.4726 28.351 16.5988 35.3238 17.4048 36.6876L18.3402 38.2702C18.5803 38.6763 19.1769 38.6859 19.4304 38.2877C20.1593 37.1438 21.6906 34.5459 22.9619 32.3352L31.37 18.111C30.1234 20.2097 27.7979 21.6211 25.1349 21.6211C22.469 21.6211 20.1413 20.2066 18.8957 18.104Z",
    fill: "url(#paint1_linear_4079_33817)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "TM"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.471 0V0.496118H163.067V4.16455H162.495V0.496118H161.091V0H164.471Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.556 0H166.364L167.56 3.52102L168.748 0H169.547V4.16455H169.012V1.70664C169.012 1.6216 169.014 1.48079 169.017 1.28424C169.021 1.08768 169.023 0.876947 169.023 0.65204L167.835 4.16455H167.277L166.08 0.65204V0.779613C166.08 0.881672 166.082 1.03759 166.086 1.24738C166.092 1.45528 166.094 1.60837 166.094 1.70664V4.16455H165.556V0Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4079_33817",
    x1: 37.4476,
    y1: 38.3207,
    x2: 0.0248451,
    y2: 38.3511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#066CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222222"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4079_33817",
    x1: -8.54558,
    y1: 23.2062,
    x2: 28.2124,
    y2: 23.5127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#066CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05A0FA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVigilLogoTm);
export default __webpack_public_path__ + "static/media/vigilLogoTM.e92e448dbdb9a11ae02e2e1144b891ab.svg";
export { ForwardRef as ReactComponent };